import { useRoutes } from "react-router-dom"

import { DetailSegmentSelectListener, SegmentSelectListener } from "@l2r-front/l2r-common"
import { MapAdapterBoundingBox, MapAdapterRoad } from "@l2r-front/l2r-networks"
import { NavigateWithParams, useUrlParams } from "@l2r-front/l2r-utils"

import { API_MODULE_EQUIPMENT } from "../../../../common/constants/modules"
import { EquipmentDetailSidebar } from "../../containers/EquipmentDetailSidebar"
import { EquipmentMobileContent } from "../../containers/EquipmentMobileContent"
import { EquipmentSelectListener } from "../../containers/EquipmentSelectListener"

import { EquipmentValidator } from "../EquipmentValidator"

export const EquipmentMobileRoutes = () => {
    const { getParams } = useUrlParams()

    const searchParams = getParams()

    const equipmentRoutes = useRoutes([
        {
            path: "/*",
            element: <>
                <MapAdapterBoundingBox module={API_MODULE_EQUIPMENT} />
                <EquipmentMobileContent />
                <SegmentSelectListener />
            </>,
        },
        {
            path: "/code/:code",
            element: <>
                <MapAdapterBoundingBox module={API_MODULE_EQUIPMENT} />
                <EquipmentMobileContent />
                <SegmentSelectListener />
            </>,
        },
        {
            path: "/:road",
            element: <>
                <DetailSegmentSelectListener />
                <MapAdapterRoad module={API_MODULE_EQUIPMENT} />
                <EquipmentMobileContent />
            </>,
        },
        {
            path: "/:road/:signId",
            element: <EquipmentValidator>
                <EquipmentSelectListener />
                <EquipmentDetailSidebar />
            </EquipmentValidator>,
        },
        {
            path: "/:road/code/:code",
            element: <>
                <DetailSegmentSelectListener />
                <MapAdapterRoad module={API_MODULE_EQUIPMENT} />
                <EquipmentMobileContent />
            </>,
        },
        {
            path: "/:road/code/:code/:signId",
            element: <EquipmentValidator>
                <EquipmentSelectListener />
                <EquipmentDetailSidebar />
            </EquipmentValidator>,
        },
        {
            path: "/:road/*",
            element: <NavigateWithParams replace to={`../:road?${searchParams}`} />,
        },
    ])

    return equipmentRoutes
}